import React from "react";
import {ISelectFieldValue, IVirtualizedTableCellComponentProps} from "../../VirtualizedTableInterfaces";
import MultiSelectDialog from "../modalDropdown/MultiSelectDialog";
import {EColumnKey} from "../../../../views/OptionsView/OptionsViewUtils";
import {Icon, Label, Loader} from "semantic-ui-react";
import HATEOASClient from "src/services/HATEOASClient";
import SelectDialog from "../modalDropdown/SelectDialog";
import {OSPGenerationDto} from "src/services/Client";

interface GenerationCellProps extends IVirtualizedTableCellComponentProps {
    item: any;
    client: HATEOASClient;
    allOSP: any;
}

interface GenerationCellState {
    toggleModal: boolean;
}

export default class GenerationCell extends React.Component<GenerationCellProps, GenerationCellState> {
    constructor(props: GenerationCellProps) {
        super(props);
        this.state = {
            toggleModal: false,
        };
    }

    saveChange = (selectedOsp: any) => {
        const generation = {
            generation: selectedOsp,
            objectId: this.props.allOSP.find((item: any) => item.objectId === selectedOsp).objectId
        };
        this.setState({toggleModal: false});
        this.props.onChange(generation);
    }

    public render() {
        const dropdownValue: any = this.props.value;
        const {allOSP} = this.props;

        return (
            <React.Fragment>
                <div
                    style={{
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        justifyContent: 'center'
                    }}
                    onClick={async () => {
                        if (!this.props.readOnly) {
                            this.setState({ toggleModal: true});
                        }
                    }}
                >
                    {
                        // @ts-ignore it will never be undefined
                        dropdownValue
                            ?
                            // @ts-ignore it will never be undefined
                            <Label
                                color="grey"
                                tag={true}
                                style={{
                                    cursor: this.props.readOnly ? "default" : "pointer",
                                    opacity: this.props.readOnly ? 0.4 : 1,
                                    marginBottom: 2
                                }}
                            >
                                {dropdownValue.generation}
                            </Label>
                            :
                            <div
                                style={{
                                    cursor: this.props.readOnly ? "default" : "pointer",
                                    opacity: this.props.readOnly ? 0.4 : 1
                                }}
                            >
                                 <Icon name='tags' />
                                {this.props.t('MT_BASIC_VIEW:ADD_GENERATION')}
                            </div>
                    }
                </div>

                {this.state.toggleModal &&
                    <SelectDialog
                        open={this.state.toggleModal}
                        title={this.props.t('MT_BASIC_VIEW:EDIT_GENERATION_TITLE')}
                        dialogText={this.props.t('MT_BASIC_VIEW:EDIT_GENERATION_DESCRIPTION')}
                        cellKey={EColumnKey.GenerationKey}
                        value={{
                            options: allOSP.map((item: any) => ({value: item.objectId, text: item.generation})),
                            // @ts-ignore it will never be undefined
                            value: dropdownValue ? dropdownValue.objectId : undefined,
                        }}
                        onChange={this.saveChange}
                        onClose={() => this.setState({toggleModal: false})}
                        customStyle={{width: '85%'}}
                    />
                }
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Table/components/basic/GenerationCell.tsx